import $ from 'jquery';
import {siteUrl} from "./url";
import {createHtmlDialog, createIframeDialog} from "../widgets/dialog";

/**
 * Shows iframe-based modal window
 * @param {string} name Modal name
 * @param {object} data Custom data to passed as GET parameters
 * @param {object} dialogOptions Options for {@link ZDialog} instance
 * @return {ZDialog}
 */
export function showModalIframe(name, data = null, dialogOptions = null) {
	data = {...data};
	for(let key in data) if(data[key] === null) delete data[key];

	const query = $.param({...data});
	const url = siteUrl('modals/' + name + (query ? '?' + query : ''));
	return createIframeDialog(url, {name, ...dialogOptions, autoOpen: true});
}



// WEBPACK FOOTER //
// ./core/utils/modal.js